import { PublicTranslationService as BlueprintPublicTranslationService, TranslationResponse } from '@capturum/complete';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiHttpService } from '@capturum/api';
import { AuthService } from '@capturum/auth';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PublicTranslationService extends BlueprintPublicTranslationService {
  constructor(
    private apiHttpService: ApiHttpService,
    private ngTranslatService: TranslateService,
    private authenticationService: AuthService,
    private primeNGConfig: PrimeNG
  ) {
    super(apiHttpService, ngTranslatService, authenticationService, primeNGConfig);
  }

  public loadFilteredTranslationsForTenant(groups?: string[], locale?: string, tenant?: string): Observable<any> {
    const params = this.getHttpParamsWithTenant(groups, locale, tenant);

    return this.apiHttpService.get<{ data: TranslationResponse }>('/translation/filtered', { params }).pipe(
      map((response) => {
        return response.data;
      }),
      this.processTranslationResponse.bind(this)
    );
  }

  private getHttpParamsWithTenant(groups?: string[], locale?: string, tenant?: string): HttpParams {
    const joinedGroups: string = groups ? groups.join(',') : null;
    const currentLanguage = locale ?? this.ngTranslatService.currentLang;
    let params: HttpParams = new HttpParams();

    if (joinedGroups) {
      params = params.append('groups', joinedGroups);
    }

    if (currentLanguage) {
      params = params.append('locale', currentLanguage);
    }

    if (tenant) {
      params = params.append('tenant', tenant);
    }

    return params;
  }
}
